import { render, staticRenderFns } from "./chapterIndex.vue?vue&type=template&id=31cb8e7b&scoped=true"
import script from "./chapterIndex.vue?vue&type=script&lang=js"
export * from "./chapterIndex.vue?vue&type=script&lang=js"
import style0 from "./chapterIndex.vue?vue&type=style&index=0&id=31cb8e7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cb8e7b",
  null
  
)

export default component.exports